import t from 'tcomb';
import Natural from './Natural';

const Number_Format = t.struct({
  decimal_symbol: t.Str,
  digits: Natural,
  grouping_symbol: t.Str,
  infinity: t.Str,
  negative_suffix: t.Str,
  positive_suffix: t.Str
}, 'Number_Format');

// true se s è la rappresentazione in stringa di un numero JavaScript
const is_numeric_regexp = /^-{0,1}\d*\.{0,1}\d+$/;

const is_numeric = (s) => {
  return is_numeric_regexp.test(s);
};
// se s è parsabile un numero altrimenti null
Number_Format.prototype.parse_number = function(s: t.String) {

  var escape_regexp = function(s) {
    return s.replace(/([.*+?^${}()|[\]\/\\])/g, '\\$1');
  };

  // elimina i simboli di raggruppamento delle migliaia
  // e il simbolo della virgola con la virgola JavaScript
  var make_parseable = function(fmt, s) {
    var grouping_symbol_re = new RegExp(escape_regexp(fmt.grouping_symbol), 'gm');
    var decimal_symbol_re = new RegExp(escape_regexp(fmt.decimal_symbol), 'gm');
    var without_grouping = s.replace(grouping_symbol_re, "");
    return without_grouping.replace(decimal_symbol_re, ".");
  };

  var parseable = make_parseable(this, s);
  return is_numeric(parseable) ? parseFloat(parseable) :
    parseable === this.infinity ? Infinity :
    parseable === this.negative_suffix + this.infinity ?
    -Infinity : null;
};

export default Number_Format;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Number_Format.js
 **/